import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import ReserveRequest from "../../magData/Bus/ReserveRequest";
import ReserveResponse from "../../magData/Bus/ReserveResponse";

function BusReservePage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Bus Reserve Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/bus/reserve</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Search Key</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
                <tr>
                  <td>passengers</td>
                  <td>
                    passengers
                  </td>
                  <td>Collection of String</td>
                  <td><Badge bg="warning" text="dark">
                    None
                  </Badge></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>firstName</td>
                          <td>firstName</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>lastName</td>
                          <td>lastName</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>seatNumber</td>
                          <td>seatNumber</td>
                          <td>Integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>nationalCode</td>
                          <td>nationalCode</td>
                          <td>String</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                        <tr>
                          <td>gender</td>
                          <td>gender</td>
                          <td>Integer</td>
                          <td>
                            <Badge bg="warning" text="dark">
                              None.
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>contact</td>
                  <td>contact</td>
                  <td>Collection of String</td>
                  <td><Badge bg="warning" text="dark">None.</Badge></td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>name</td>
                          <td>
                            name
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>mobilePhone</td>
                          <td>
                            mobilePhone
                          </td>
                          <td>String</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(ReserveRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>success</td>
                  <td>success</td>
                  <td>boolean </td>
                  <td>None.</td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>token</td>
                  <td>
                    token
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>busId</td>
                  <td>
                    busId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>price</td>
                  <td>
                    price
                  </td>
                  <td>Integer</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>financial</td>
                  <td>
                    financial
                  </td>
                  <td>Collection of string</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td colSpan={4}>
                    <Table bordered>
                      <tbody>
                        <tr>
                          <td>price</td>
                          <td>
                            price
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>maxApplicableDiscountPercentage</td>
                          <td>
                            maxApplicableDiscountPercentage
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>availablePaymentMethods</td>
                          <td>
                            availablePaymentMethods
                          </td>
                          <td>Collection of string</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                        <tr>
                          <td>commissionPercentage</td>
                          <td>
                            commissionPercentage
                          </td>
                          <td>Integer</td>
                          <td>
                            <p>None.</p>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </td>
                </tr>
                <tr>
                  <td>verId</td>
                  <td>
                    verId
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>errorMessage</td>
                  <td>
                    errorMessage
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
                <tr>
                  <td>reserveCode</td>
                  <td>
                    reserveCode
                  </td>
                  <td>String</td>
                  <td>
                    <p>None.</p>
                  </td>
                </tr>
            </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(ReserveResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default BusReservePage;